import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcDone32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m5 17.032c0-.58.484-1 1-1 .387 0 .484.065.71.29l5.29 5.26 13.258-13.292a.925.925 0 0 1 .71-.291c.58.001 1.032.517 1.032 1.001 0 .258-.097.484-.323.71l-13.967 14c-.194.193-.452.29-.71.29a.925.925 0 0 1 -.71-.29l-6-5.968a1 1 0 0 1 -.29-.71z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcDone32;
